module.exports = __webpack_public_path__ + "img/sameday_cod.b99b7e8e.png";